import { WorkflowSection } from '@ebalance/proto/bffuser/v1/workflow_template_model_pb'

import { type FieldCodec, INVALID, field } from '~/models/filterCodec'
import { canonicalWorkflowSection } from '~/models/workflowSection'

/** 保存値を単日へ正規化した上で、画面の選択肢に含まれる値だけ復元する。 */
export const workflowSectionFilter = (
  allowed: readonly WorkflowSection[],
): FieldCodec<WorkflowSection | null> =>
  field<WorkflowSection | null>((wire) => {
    if (wire === null) return null
    if (typeof wire !== 'number') return INVALID
    const section = canonicalWorkflowSection(wire as WorkflowSection)
    return allowed.includes(section) ? section : INVALID
  })
